import { AbstractControl, ValidatorFn } from '@angular/forms';

export function numberDecimalPlacesValidator(
  maxPrecision: number
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const rawValue = control.value;

    if (rawValue == null || rawValue === '') {
      return null; // prázdná hodnota nevadí
    }

    // převedu číslo na string abych se vyhnul problémům s floaty
    const stringValue = rawValue.toString();
    let decimalPart: string | undefined;

    if (stringValue.includes('.')) {
      // oddělovačem desetinných míst je tečka
      decimalPart = stringValue.split('.')[1];
    } else if (stringValue.includes(',')) {
      // oddělovačem desetinných míst je čárka
      decimalPart = stringValue.split(',')[1];
    }

    if (!decimalPart) {
      return null; // Pokud žádná desetinná část není, je to platné
    }

    // odstraním včechny nuly na konci stringu
    decimalPart = decimalPart.replace(/0+$/, '');

    if (decimalPart.length > maxPrecision) {
      // pokud je počet desetinných míst větší než maxPrecision, validace neprojde
      return {
        decimalPlaces: {
          value: control.value,
          precision: maxPrecision,
        },
      };
    } else {
      // pokud je počet desetinných míst menší než maxPrecision, validace projde
      return null;
    }
  };
}
